export const ARTICLE = 'article';
export const QUESTION = 'question';
export const VIDEO = 'video';
export const THOUGHT = 'thought';
